import React, { useState, useEffect } from "react";
import logo from "./logo.svg";
// import { SpinningWheel } from "react-random-selection-wheel";
import Roulette from "react-roulette-game";
import { img } from "./utils/importImg";
import Winwheel from "winwheel";
import "./App.css";

function App() {
  const [mustSpin, setMustSpin] = useState(false);
  const [rotation, setRotation] = useState(0);
  let roulette_img_on_highlight = img["rou_on_high.png"];
  let roulette_img_under_highlight = img["rou_under_high.png"];
  let highlight_img = img["hightlight.png"];
  let pointer_img = img["pointer.png"];
  let set_prize = 2;
  let has_reset = false;
  const data = [
    { option: "REACT" },
    { option: "CUSTOM" },
    { option: "ROULETTE", style: { textColor: "#f9dd50" } },
    { option: "WHEEL" },
    { option: "REACT" },
    { option: "CUSTOM" },
    { option: "ROULETTE", style: { textColor: "#70bbe0" } },
    { option: "WHEEL" },
  ];
  const roulette_props = {
    roulette_img_under_highlight,
    roulette_img_on_highlight,
    highlight_img,
    pointer_img,
    set_prize,
    has_reset,
    on_complete: (prize) => demo(prize),
    prize_arr: [
      'Baseball',
      'Rugby',
      'Tennis',
      'Soccer',
      'Badminton',
      'Basketball',
    ],
  }
  const demo = prize => {
    console.log(prize)
  }
  const rotate = () => {
    let newRotation = rotation + 45;
    if (newRotation >= 360) {
      newRotation = -360;
    }
    setRotation(newRotation);
  };
  var wheelSpinning = false;
  useEffect(() => {
    setInterval(() => {
      rotate();
    }, 100)
    let loadedImg = new Image();
    var theWheel = new Winwheel({
      'numSegments': 3,
      'outerRadius': 0,
      'drawMode': 'image',
      'segments': [{
        'text': 'Prize 1'
      }, {
        'text': 'Prize 2'
      }, {
        'text': 'Prize 3'
      }
      ],
      'animation':
      {
        'type': 'spinToStop',
        'duration': 5,
        'spins': 8,
        'callbackFinished': alertPrize,
        'callbackSound': playSound
      }
    });
    var audio = new Audio('./assets/img/tick.mp3');
    function playSound() {
      audio.pause();
      audio.currentTime = 0;
      audio.play();
    }
    // var loadedImg = new Image();
    loadedImg.onload = function () {
      theWheel.wheelImage = loadedImg;
      theWheel.draw();
    }
    loadedImg.src = "./assets/img/planes.png";
    var wheelPower = 0;
    var wheelSpinning = false;
    function startSpin() {
      if (wheelSpinning == false) {
        theWheel.animation.spins = 5;
        // $("#spin-form input").prop('disabled', true);
        theWheel.startAnimation();
        wheelSpinning = true;
      }
    }
    function calculatePrize() {
      var stopAt = theWheel.getRandomForSegment(1);
      theWheel.animation.stopAngle = stopAt;
      theWheel.startAnimation();
    }
    function alertPrize(indicatedSegment) {
      alert("The wheel stopped on " + indicatedSegment.text);
    }
    loadedImg.onload = function () {
      theWheel.wheelImage = loadedImg; // Make wheelImage equal the loaded image object.
      theWheel.draw(); // Also call draw function to render the wheel.
    };
    loadedImg.src =
      "http://5002047-s3user.cloudstorage.com.vn/clappigames/lqmt/08lQKS9bc-GÓI-CÀN-QUÉT.jpg";
    // theWheel.drawPointerGuide()
  }, []);
  function alertPrize(indicatedSegment) {
    // Do basic alert of the segment text.
    alert("You have won " + indicatedSegment.text);
  }
  const backgroundColors = ["#ff8f43", "#70bbe0", "#0b3351", "#f9dd50"];
  const textColors = ["#0b3351"];
  const outerBorderColor = "#eeeeee";
  const outerBorderWidth = 10;
  const innerBorderColor = "#30261a";
  const innerBorderWidth = 0;
  const innerRadius = 0;
  const radiusLineColor = "#eeeeee";
  const radiusLineWidth = 8;
  const fontSize = 17;
  const textDistance = 60;
  // const display= (spinResult) => {
  //   return <img src={`${spinResult}`} alt={"result"} />
  // }
  const wheelOptions = {
    1: {
      image: "./foo.jpg",
      result: "./foo.jpg",
    },
    2: {
      image: "./bar.jpg",
      result: "./bar.jpg",
    },
  };
  // const rotate = () => {
  //   let newRotation = this.state.rotation + 45;
  //   if (newRotation >= 360) {
  //     newRotation = -360;
  //   }
  //   setRotation(newRotation);
  // };
  return (
    <div className="App">
      {/* <Wheel
        mustStartSpinning={mustSpin}
        prizeNumber={0}
        data={data}
        backgroundColors={backgroundColors}
        textColors={textColors}
        fontSize={fontSize}
        outerBorderColor={outerBorderColor}
        outerBorderWidth={outerBorderWidth}
        innerRadius={innerRadius}
        innerBorderColor={innerBorderColor}
        innerBorderWidth={innerBorderWidth}
        radiusLineColor={radiusLineColor}
        radiusLineWidth={radiusLineWidth}
        // perpendicularText
        textDistance={textDistance}
      />
      <button className={"spin-button"} onClick={() => setMustSpin(true)}>
        SPIN
      </button> */}
      {/* <img
        style={{ transform: `rotate(${rotation}deg)` }}
        src={
          "//blog-assets.risingstack.com/2016/Jan/react_best_practices-1453211146748.png"
        }
        onClick={rotate}
        width="600"
        height="167"
      /> */}
      
      <div className='game-box' style={{ width: "300px" }}>
        <Roulette {...roulette_props} />
      </div>
      <canvas id="myCanvas" width="880" height="300"></canvas>
      {/* <img id="prizePointer" src={img["pointer.png"]} alt="V" /><button onClick={demo2}>đ</button> */}
    </div>
  );
}

export default App;
